import { useSelector } from 'react-redux';
import { Team } from 'new/entities/Team';
import { User } from 'new/entities/User';
import { useMemo } from 'react';

export function useTeams() {
  const teamsObj = useSelector<Team[]>((state: any) => state?.entities?.teams);
  const teams = Object.values(teamsObj) as Team[];
  const users = useSelector((state: any) => state.entities.users) as {
    [key: string]: User;
  };
  return useMemo(() => {
    return teams.map((team) => ({
      ...team,
      members: team.members.map((member) => users[member.id] || member),
    }));
  }, [teamsObj, users]);
}
